import Map from 'ol/Map.js';
import $ from 'jquery';
import {Fill, Icon, Stroke, Style} from 'ol/style.js';
import View from 'ol/View.js';
import KML from 'ol/format/KML.js';
import Overlay from 'ol/Overlay.js';
import Feature from 'ol/Feature.js';
import {fromLonLat} from 'ol/proj.js';
import {Point} from 'ol/geom.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import BingMaps from 'ol/source/BingMaps.js';
import VectorSource from 'ol/source/Vector.js';
import OSM from 'ol/source/OSM';
import {defaults as defaultInteractions, Pointer as PointerInteraction} from 'ol/interaction.js';

export default function initMap() {
	
  function init() {
    var container = document.getElementById('popup');
    var closer = document.getElementById('popup-closer');
    var content = document.getElementById('popup-content');
    var tooltip = document.getElementById('tooltip');
    
    $('#map').empty();
    
    var overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });

    var tile = new TileLayer({
      source: new OSM()
    });

    closer.onclick = function() {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    var map = new Map({
      layers: [tile],
      interactions: defaultInteractions({mouseWheelZoom:false}),
      target: document.getElementById('map'),
      overlays: [overlay],
      view: new View({
        center: fromLonLat([9.899030,46.173970]),
        zoom: 14
      })
    });
    
    var iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 46],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        //src: 'assets/images/ico-marker.png'
        src: '/contents/instance2/images/ico-marker.png'
      })
    });	
    
    if ($('.luogo').length > 0) { 
      var lng = $('.luogo').data('lng');
      var lat = $('.luogo').data('lat');
      var luogoTitolo = $('.luogo').data('title');
      var zoom = $('.luogo').data('zoom');
      
      

      var marker = new Feature({
        name: luogoTitolo,
        description: "<p>luogoTitolo</p>",
        geometry: new Point(
          fromLonLat([Number(lng),Number(lat)])
        ), 
      });
      marker.setStyle(iconStyle);
      
      var vector = new VectorLayer({
        source: new VectorSource({
          features: [marker]
        })
      });

      map.addLayer(vector);
      map.getView().setCenter(fromLonLat([Number(lng),Number(lat)]));
      map.getView().setZoom([Number(zoom)]);
      
      map.on('pointermove', function(evt) {
        if (evt.dragging) {
          return;
        }
        var pixel = evt.pixel;
        
        var features = [];
        map.forEachFeatureAtPixel(pixel, function(feature) {
          features.push(feature);
        });
        
        if (features.length > 0) {
          map.getTarget().style.cursor = 'pointer';
        } else {
          map.getTarget().style.cursor = '';
        }
      });
    } else if ($('.kml').length > 0) {
     
      var settings = {
        //kml: '/assets/images/it_mappa-eventi.kml',
        kml: '/contents/instance2/static/it_mappa-eventi.kml',
        zoom: 14,
        //center: fromLonLat([Number(lng),Number(lat)])
      }
      //Circuito dei Castelli Grumello e Mancapane
      if ($('#card_3').length > 0) {
        //settings.kml = '/assets/images/castelli-grumelli.kml';
        settings.kml = '/contents/instance2/static/itinerari/3_circuito-dei-castelli-grumello-e-mancapane.kml';
      }
      //Via dei Palazzi
      if ($('#card_27').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/27_via-dei-palazzi.kml';
      }
      //Parco Adda Mallero - Renato Bartesaghi
      if ($('#card_42').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/42_parco-adda-mallero-renato-bartesaghi.kml';
      }
      //La via dei terrazzamenti
      if ($('#card_48').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/48_la-via-dei-terrazzamenti.kml';
      }
      //Sentiero Valtellina
      if ($('#card_49').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/49_sentiero-valtellina.kml';
      }
      //Sentiero Rusca
      if ($('#card_67').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/67_sentiero-rusca.kml';
      }
      //Bosco dei Bordighi
      if ($('#card_68').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/68_bosco-dei-bordighi.kml';
      }
      //Anello delle Cassandre
      if ($('#card_69').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/69_anello-delle-cassandre.kml';
      }
      //Anello della Sassella e delle rupi del vino
      if ($('#card_70').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/70_anello-della-sassella-e-delle-rupi-del-vino.kml';
      }
      //Sentiero dei Ricordi
      if ($('#card_82').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/82_sentiero-dei-ricordi.kml';
      }
      //Wine Bike Tour 1 - Famiglia
      if ($('#card_410').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/410_wine-bike-tour.kml';
      }
      //Wine Bike Tour 2 - Adrenalina
      if ($('#card_412').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/412_wine-bike-tour-adrenalina.kml';
      }
      //Wine Bike Tour 3 - Natura
      if ($('#card_413').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/413_wine-bike-tour-natura.kml';
      }
      //Wine Bike Tour 4 - Arte
      if ($('#card_414').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/414_wine-bike-tour-arte.kml';
      }
      //Wine Bike Tour 5 - Frazioni
      if ($('#card_416').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/416_wine-bike-tour-frazioni.kml';
      }
      //Wine Bike Tour 6 - Storia
      if ($('#card_417').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/417_wine-bike-tour-storia.kml';
      }
      //Trekking urbano 1 - Ti racconto Sondrio
      if ($('#card_486').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/486_trekking-urbano-1.kml';
      }
      //Trekking urbano 2 - Ti racconto Sondrio
      if ($('#card_487').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/487_trekking-urbano-2.kml';
      }
      //Parcheggi Top Luogo
      if ($('#article_55').length > 0 || $('#article_86').length > 0 || $('#article_215').length > 0 || $('#article_220').length > 0 || $('#article_35').length > 0) {
        settings.kml = '/contents/instance2/static/itinerari/parcheggi.kml';
      }
      
      var vector = new VectorLayer({
        source: new VectorSource({
          url: settings.kml,
          format: new KML()
        })
      });
      
      map.addLayer(vector);
      
      if ($(".topluogo").length>0) {
        var lng = $('.topluogo').data('lng');
        var lat = $('.topluogo').data('lat');
        var luogoTitolo = $('.topluogo').data('title');
        var marker = new Feature({
          name: luogoTitolo,
          geometry: new Point(
            fromLonLat([Number(lng),Number(lat)])
          ), 
        });
        marker.setStyle(iconStyle);
        
        var vector = new VectorLayer({
          source: new VectorSource({
            features: [marker]
          })
        });

        map.addLayer(vector);
        map.getView().setCenter(fromLonLat([Number(lng),Number(lat)]));
        map.getView().setZoom(17);
      } else {
        var vectorSource = vector.getSource();
        vectorSource.once('change', function(e){
          if (vectorSource.getState() === 'ready') {
            var extent = vectorSource.getExtent();
            map.getView().fit(extent);
          }
        });
      }
      
      map.on('pointermove', function(evt) {
        if (evt.dragging) {
          return;
        }
        var pixel = evt.pixel;
        var features = [];
        map.forEachFeatureAtPixel(pixel, function(feature) {
          features.push(feature);
        });
        
        if (features.length > 0) {
          map.getTarget().style.cursor = 'pointer';
          if (features.length > 0) {
            var info = [];
            var i, ii;
            for (i = 0, ii = features.length; i < ii; ++i) {
              info.push(features[i].get('name'));
            }
            tooltip.innerHTML = info.join(', ');
            tooltip.style.position = "absolute";
            tooltip.style.display = "block";
            tooltip.style.left = (pixel[0] + 20) +'px';
            tooltip.style.top = (pixel[1] + 15) +'px';
          }
        } else {
          map.getTarget().style.cursor = '';
          tooltip.style.display = "none";
        }
      });
    }
    
    map.on('singleclick', function(evt) {
      displayFeatureInfo(evt);
    });
    
    var displayFeatureInfo = function(evt) {
      var pixel = evt.pixel;
      var coordinate = evt.coordinate;
      var features = [];
      map.forEachFeatureAtPixel(pixel, function(feature) {
        features.push(feature);
      });
      if (features.length > 0) {
        var info = {};
        var i, ii;
        for (i = 0, ii = features.length; i < ii; ++i) {
          info.name = features[i].get('name');
          info.description = features[i].get('description');
        }
        tooltip.style.display = "none";
        content.innerHTML = '<strong>'+info.name+'</strong><br/>'+(info.description || '');
        overlay.setPosition(coordinate);
        map.getTarget().style.cursor = 'pointer';
      } else {
        
        map.getTarget().style.cursor = '';
      }
    };
  }
	
  if($('#map').length > 0) {
    init();
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/maps.js